import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, map } from 'rxjs';
import { ContractDetailAddRequest, ContractDetailEditRequest, ContractIdResponse, DeactivateServiceConceptRequest, DebRepayment, DebRepaymentAddRequest, DebRepaymentEditRequest, DebRepaymentForm, ServiceConcept } from '../interfaces/serviceConcept';
import { plainToInstance } from 'class-transformer';
import { IntervalPrice } from '../interfaces/intervalPrice';
import { ServiceConceptDataReq } from '../interfaces/serviceConceptDataReq';
import { Contract, ContractResponse } from '../../contract/interfaces/contract';
import { ContractAddRequest, ContractData, ContractDataRequest } from '../../contract/interfaces/contractData';
import { ServiceConceptData } from '../interfaces/serviceConceptData';

@Injectable({
  providedIn: 'root'
})
export class ServiceConceptsService {

  private apiUrl = `${environment.sgcApi}`;
  private contractRoute = 'contract';
  private conceptServiceRoute = 'conceptService';
  private debRepaymentRoute = 'debRepayment';

  constructor(
    private httpClient: HttpClient
  ) { }


  getContractById(contractId: number): Observable<ContractResponse> {
    let endpoint = `${this.apiUrl}${this.contractRoute}/${contractId}`;
    return this.httpClient.get<any>(endpoint).pipe(map(data => {
      return plainToInstance(ContractResponse, data as ContractResponse);
    }));
  }

  getServiceConceptsByContractId(contractId: number): Observable<ServiceConcept[]> {
    let endpoint = `${this.apiUrl}${this.conceptServiceRoute}/contractId/${contractId}`;
    return this.httpClient.get<any>(endpoint).pipe(map(data => {
      return plainToInstance(ServiceConcept, data as ServiceConcept[]);
    }));
  }

  getDebRepayments(serviceConceptId: number): Observable<DebRepayment[]> {
    let endpoint = `${this.apiUrl}${this.debRepaymentRoute}/serviceConceptId/${serviceConceptId}`;
    return this.httpClient.get<any>(endpoint).pipe(map(data => {
      return plainToInstance(DebRepayment, data as DebRepayment[]);
    }));
  }

  createServiceConcept(serviceConcept: ServiceConceptDataReq, user: string) {
    let endpoint = `${this.apiUrl}${this.conceptServiceRoute}/user/${user}`;
    return  this.httpClient.post<any>(endpoint, serviceConcept).pipe(
      map(data => data)
    );
  }

  createIntervalPrice(intervalPrice: IntervalPrice, user: string) {
    let endpoint = `${this.apiUrl}${this.conceptServiceRoute}/user/${user}/interval`;
    return  this.httpClient.post<any>(endpoint, intervalPrice).pipe(
      map(data => data)
    );
  }

  createContractHeader(contractData: ContractAddRequest): Observable<ContractIdResponse>  {
    let endpoint = `${this.apiUrl}${this.contractRoute}`;
    return  this.httpClient.post<any>(endpoint, contractData).pipe(
      map(data => {
        return plainToInstance(ContractIdResponse, data as ContractIdResponse);
      })
    );
  }

  createDebRepayment(debRepayment: DebRepaymentAddRequest, user: string){
    let endpoint = `${this.apiUrl}${this.debRepaymentRoute}/user/${user}`;
    return  this.httpClient.post<any>(endpoint, debRepayment).pipe(
      map(data => data)
    );
  }

  createContractDetail(contractDetail: ContractDetailAddRequest, user: string) {
    let endpoint = `${this.apiUrl}${this.contractRoute}/user/${user}/details`;
    return  this.httpClient.post<any>(endpoint, contractDetail).pipe(
      map(data => data)
    );
  }

  updateContractHeader(contractData: ContractDataRequest, user: string) {
    let endpoint = `${this.apiUrl}${this.contractRoute}/user/${user}`;
    return  this.httpClient.put<any>(endpoint, contractData).pipe(
      map(data => data)
    );
  }

  updateServiceConcept(serviceConceptData: ServiceConceptData, user: string) {
    let endpoint = `${this.apiUrl}${this.conceptServiceRoute}/user/${user}`;
    return  this.httpClient.put<any>(endpoint, serviceConceptData).pipe(
      map(data => data)
    );
  }

  updateIntervalPrice(intervalPricesPutReq: any, user: string) {
    let endpoint = `${this.apiUrl}${this.conceptServiceRoute}/user/${user}/interval/massive`;
    return  this.httpClient.put<any>(endpoint, intervalPricesPutReq).pipe(
      map(data => data)
    );
  }

  updateDebRepayment(debRepayment: DebRepaymentEditRequest, user: string) {
    let endpoint = `${this.apiUrl}${this.debRepaymentRoute}/user/${user}`;
    return  this.httpClient.put<any>(endpoint, debRepayment).pipe(
      map(data => data)
    );
  }

  updateContractDetail(contractDetail: ContractDetailEditRequest, user: string) {
    let endpoint = `${this.apiUrl}${this.contractRoute}/user/${user}/details`;
    return  this.httpClient.put<any>(endpoint, contractDetail).pipe(
      map(data => data)
    );
  }

  deleteContractDetail(contractId: number, contractDetailId: number) {
    let endpoint = `${this.apiUrl}${this.contractRoute}/contractId/${contractId}/contractDetailId/${contractDetailId}`;
    return  this.httpClient.delete<any>(endpoint).pipe(
      map(data => data)
    );
  }

  deactivateServiceConcept(deactivateServiceConceptRequest: DeactivateServiceConceptRequest, user: string) {
    let endpoint = `${this.apiUrl}${this.conceptServiceRoute}/user/${user}/desactivate`;
    return  this.httpClient.put<any>(endpoint, deactivateServiceConceptRequest).pipe(
      map(data => data)
    );
  }
}
